import { ref } from 'vue'
import { defineStore } from 'pinia'
import { useRequestsStore } from '@/stores/requests'
import { useTokenStore } from '@/stores/token'

export const useTestStore = defineStore('test', () => {

    const requestsStore = useRequestsStore()
    const tokenStore    = useTokenStore()

    const testResponse        = ref(null)
    const testRequestProcess  = ref(false)
    const testRequestMsg      = ref(null)

    async function sendTestRequest(data) {

        testRequestProcess.value = true
        const token = tokenStore.access

        if(token) {

            let request

            if(data.method == 'POST' || data.method == 'PUT') {

                let payload = {
                    address: data.address, 
                    method: data.method, 
                    token: data.token,
                    data: data.params,
                    type: data.type
                }

                if(data.headers) payload.headers = data.headers

                request = await requestsStore.fetchRequest(payload)

            } else {

                let params = ''

                if(data.params) {

                    for( let param in data.params) {

                        if(Array.isArray(data.params[param])) {
                            data.params[param].map( el => {
                                params.length ?
                                    params += '&' + param + '=' + el :
                                    params = '?' + param + '=' + el
                            })
                        } else {
                            params.length ?
                                params += '&' + param + '=' + data.params[param] :
                                params = '?' + param + '=' + data.params[param]
                        }
                    }
                }

                let payload = {
                    address: data.address + params, 
                    method: data.method, 
                    token: data.token
                }

                if(data.headers) payload.headers = data.headers

                request = await requestsStore.fetchRequest(payload)
            }

            if(!('error' in request)) {

                testResponse.value = request
                testRequestMsg.value = { success: true, status: request.status }

            } else {
                
                testResponse.value = request
                testRequestMsg.value = { success: false, status: request.status, text: { statusText: `Ошибка запроса: ${request.error.statusText}`, response: request.error.response } }
            }

        } else {

            testRequestMsg.value = { success: false, status: '', text: 'Сначала авторизуйся' }
        }

        testRequestProcess.value = false
    }

    const setTestRequestMsg = data => testRequestMsg.value = data

    return {

        testResponse, 
        testRequestProcess, 
        testRequestMsg, 
        sendTestRequest, 
        setTestRequestMsg
    }
})
